import UploadProgressBar from 'app/components/UploadProgressBar';

const FaviconUploadProgressBar = props => {
  const {
    accessCodePage
  } = props;

  // this fileId matches the one in useAccessCodePageFaviconUploadForm
  let fileId = accessCodePage.id + '-favicon';

  return <UploadProgressBar {...{ fileId }} />;
}

export default FaviconUploadProgressBar;
